import React, { useEffect, useState } from "react";
import KonsentrasiPemberdayaan from "../../Components/konsentrasi/konsentrasi";
import NavbarThree from "../../Components/Navbar/navbarThree";
import Footer from "../../Components/Footer";

const KonsenPages = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
  return (
    <>
      <NavbarThree isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />

      <div className="pt-16">
        <KonsentrasiPemberdayaan />
      </div>

      <Footer />
    </>
  );
};

export default KonsenPages;
